export default [{"url":"https://taupe-0.api.invexerp.io","name":"Branch 1","port":"5005","isStore":true,"isHQ":true}]